import { Typography } from 'antd'
import { useSelector } from 'react-redux'
import { getMunicipality } from '../../store/beslutsstod/municipalitySlice'
import ExtraTaskTable from './components/extraTaskTable'
import { JSONLoadError } from './utils/jsonLoader'

interface Props {
  loadingErrors?: JSONLoadError[]
}

const Other = ({ loadingErrors }: Props) => {
  const municipalityData = useSelector(getMunicipality)
  const extraTasks = municipalityData?.input.extraTasks ?? []

  if (extraTasks.length === 0) return null

  return (
    <div className="mt-6 mb-6">
      <Typography.Title level={3} className="mb-2 text-left">
        Övriga insatser
      </Typography.Title>
      <ExtraTaskTable tasks={extraTasks} loadingErrors={loadingErrors} />
    </div>
  )
}

export default Other
